import axios from 'axios';
import router from '../routes';
import store from '../stores';
import helpers from "../helpers";
import sjcl from "sjcl";

var url_api = "";

var api = axios.create({
  responseType: 'json'
});

var habilitaLoading = true;

helpers.getEnv().then(async (env) => {
  url_api = await env.VUE_APP_URL_API + "/portal_multas";
  api.defaults.baseURL = url_api;
});

var filaRequisicoes = [];

api.interceptors.request.use((config) => {

  if (store.getters.isAuthenticated) {
    return store.dispatch("REFRESH_TOKEN")
      .then(() => {
        config.headers.Authorization = 'Bearer ' + store.getters.token;

        if (config.baseURL == url_api && !config.disableLoading) {
          //O loading sera controlado por uma fila, de forma ele sera exibido enquanto existir requisicoes na fila para processar
          filaRequisicoes.push(config);
          if (habilitaLoading) {
            router.app.carregando = true;
          }
          habilitaLoading = true;
        }
        return config;
      }).catch(() => {
        store.dispatch('LOGOUT_REQUEST')
      });
  } else {
    config.headers.Authorization = 'Bearer ' + store.getters.token;

    if (config.baseURL == url_api) {
      //O loading sera controlado por uma fila, de forma ele sera exibido enquanto existir requisicoes na fila para processar
      filaRequisicoes.push(config);
      router.app.carregando = true;
    }

    return config;
  }
});


function l(e){var t,c={ciphertext:e,key:sjcl.codec.hex.toBits(router.app.$hkey),iv:sjcl.codec.hex.toBits(router.app.$hsiv),mode:"gcm",tag:"64"},s=c.iv,i=c.key,o=c.ciphertext;if(0!==o.length&&(c.password||c.key.length))return o=sjcl.codec.base64.toBits(o),t=new sjcl.cipher.aes(i),c.plaintext=sjcl.codec.utf8String.fromBits(sjcl.mode[c.mode].decrypt(t,o,s,c.adata,c.tag)),JSON.parse(c.plaintext)}


api.interceptors.response.use(
  (response) => {
    if (response.config.baseURL == url_api) {
      //...apenas será invisivel quando a fila estiver esvaziada...
      if (filaRequisicoes.length > 0)
        filaRequisicoes.splice(0, 1);

      if (filaRequisicoes.length <= 0)
        router.app.carregando = false;
    }

    if(response.config.responseType != "blob"){
      var dfs = l(response.data);
      response.data = dfs.original;
    }
    return response;
  },
  (error) => {
    filaRequisicoes.length = [];
    router.app.carregando = false;
 
    if (error?.config.baseURL == url_api && !error?.config?.disableCatchErrorDefault){
      if (error?.response?.data?.error && error.response.data.error.handledError){
        store.commit('setMensagensAlert', error.response.data.error?.errors);
      }else if (error?.response?.data?.errors && error.response.data.handledError){
        store.commit('setMensagensAlert', error.response.data.errors);
      }else{
        store.commit('setMensagensAlert', 'Desculpe, algo deu errado. Tente novamente. Se o problema persistir, gentileza reportar.');
      }
    }

    return Promise.reject(error);
  }
);

export default {

  Multa: {
    listarGuiasPagamento(params) {
      return api.get("/multa/listarguiaspagamento", { params });
    },
    buscarAit(params) {
      return api.get("/multa/buscar-ait-detalhamento", { params });
    },
    listar(params) {
      return api.get("/multa/listar", { params });
    },
    buscarlistaRestituicao(params) {
      return api.get("/multa/buscar-lista-restituicao", { params, disableLoading: true });
    },    
    buscarListaJari(params) {
      return api.get("/multa/buscar-lista-jari-ait", { params, disableLoading: true });
    },
    buscarListaCetran(params) {
      return api.get("/multa/buscar-lista-cetran-ait", { params, disableLoading: true });
    },
    buscarNIT(params) {
      return api.get("/multa/buscar-nit-ait", { params, disableLoading: true });
    },
    buscarPessoasAit(params) {
      return api.get("/multa/buscar-pessoas-ait", { params, disableLoading: true });
    },
    buscarSolicitacaoFici(params) {
      return api.get("/multa/buscar-solicitacao-fici", { params, disableLoading: true });
    },
    buscarTitularInfracaoNit(params) {
      return api.get("/multa/buscar-titular-ait-nit", { params, disableLoading: true });
    },
    buscarTitularInfracaoNap(params) {
      return api.get("/multa/buscar-titular-ait-nap", { params, disableLoading: true });
    },
    buscarListaDefesa(params) {
      return api.get("/multa/buscar-lista-defesa-ait", { params, disableLoading: true });
    },
    buscarListaAdvertencia(params) {
      return api.get("/multa/buscar-lista-advertencia-ait", { params, disableLoading: true });
    },
    buscarResourceAitPorTipo(params) {
      return api.get("/multa/buscar-resource-ait-por-tipo", { params});
    },
    gerarFormularioFici(params) {
      this.disableLoading = true;
      return api.post("/multa/formulario-fici", params);
    },
    buscarTitularesAit(params) {
      return api.get("/multa/buscar-titulares-ait", { params, disableLoading: true });
    },
    downloadGuiaAit(params) {
      return api.get("/multa/download-guia-ait", {params});
    },
    listarPerguntaFrequente() {
      return api.get("/listar-pergunta-frequente");
    },
    listarUrlServico() {
      return api.get("/listar-url-servico");
    },
    buscarDetalhamentoErros(params){
      return api.get("/multa/buscar-erros", {params, disableLoading: true});
    },
    excel(params) {
      return api.get("/multa/excel", {
        params,
        responseType: 'blob' // important
      });
    },
    buscarNAP(params) {
      return api.get("/multa/buscar-nap-ait", { params, disableLoading: true });
    },
    buscarLocaInfracaoCompleto(params) {
      return api.get("/multa/buscar-local-infracao-completo", { params, disableLoading: true });
    },
    verificaProprietario(params) {
      return api.get("/multa/habilitadoprop", { params, disableLoading: true });
    },

    verificaCpfCnpjAssociadoPessoaAit(params){
      return api.get("/multa/verifica-cpfcnpj-associado-pessoaait", { params });
    },
    buscarDetalhamentoNic(params) {
      return api.get("/multa/buscar-nic-detalhamento", {params});
    },    
  },


  Storage: {
    recuperarMidia(params) {
      return api.get("/storage/recuperar-midia", { params,disableLoading: true  });
    },
    convertMidia(params) {
      return api.post("/storage/convert-midia", params, {
        responseType: 'blob'// Necessário para download corretamente
      });
    },
    downloadMidia(params) {
      return api.get("/storage/download-midia", {
        params,
        responseType: 'blob'// Necessário para download corretamente
      });
    }
  },
}